"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopySerializable = void 0;
// Only works for objects that are serializable.
// See https://developer.mozilla.org/en-US/docs/Glossary/Deep_copy for more info.
function deepCopySerializable(obj) {
    return JSON.parse(JSON.stringify(obj));
}
exports.deepCopySerializable = deepCopySerializable;
